import { createTheme } from '@mui/material/styles';

import { breakpoints } from 'src/design-tokens/primitives';
import { components } from 'theme/components';
import { focusRing, palette } from 'theme/palette';
import { muiShadows } from 'theme/shadows';
import { focusRing as focusRingShadow } from 'theme/theme.helpers';
import { typography } from 'theme/typography';
import { zIndex } from 'theme/z-index';

export const marketviewMuiTheme = createTheme({
  palette,
  typography,
  shadows: muiShadows,
  breakpoints: {
    values: { ...breakpoints },
  },
  focusVisible: {
    outlineColor: 'transparent',
    outlineOffset: 0,
    boxShadow: focusRingShadow(focusRing.secondary.default),
  },
  zIndex,
  components,
});

export default marketviewMuiTheme;
